export const SET_APP_LOADING = "SET_APP_LOADING";
export const SET_SESSION = "SET_SESSION";
export const SET_KEY = "SET_KEY";
export const UPDATE_APP_DATA = "UPDATE_APP_DATA";
